import Ukiyo from 'ukiyojs';

export default class Parallax
{
    constructor() {
        this.parallax = document.querySelectorAll(".parallax");
        if (this.parallax) {
            this.parallax.forEach(item => {
                new Ukiyo(item, {
                    scale: 1.25,
                    speed: 1.25
                });
            })
        }
    }
}